export enum ProductCategory {
  Book = "book",
  Activity = "activity",
  MembershipPlan = "membershipPlan"
}